import { render, staticRenderFns } from "./Mylove.vue?vue&type=template&id=63b5409a&scoped=true"
import script from "./Mylove.vue?vue&type=script&lang=js"
export * from "./Mylove.vue?vue&type=script&lang=js"
import style0 from "./Mylove.vue?vue&type=style&index=0&id=63b5409a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5409a",
  null
  
)

export default component.exports